/* eslint-disable no-tabs */
import { Avatar, Divider, Flex } from '@chakra-ui/react'
import { ButtonCmp } from '../../../../../components/ButtonCmp'
import { ModalBase } from '../../../../../components/ModalBase'
import { iNomeId } from '../../../../../interfaces'

interface props {
  isOpen: boolean
  isPDI: boolean
  onRequestClose: () => void
  calibracoes: iNomeId[]
}

export const ModalCalibracoes: React.FC<props> = ({ isOpen, onRequestClose, calibracoes, isPDI }) => {
  function ObterNomeStatus(realizado: boolean, aprovacao?: boolean): string {
    if (aprovacao) return 'Aguardando aprovação'

    if (!realizado) return isPDI ? 'Aguardando preenchimento' : 'Aguardando calibração'

    return isPDI ? 'Preenchido' : 'Calibração realizada'
  }

  function ObterCorStatus(realizado: boolean): string {
    if (!realizado) return 'var(--Orange)'

    return 'var(--Green3)'
  }

  return (
        <ModalBase
            isOpen={isOpen}
            onClose={onRequestClose}
            Titulo={isPDI ? 'Status por preenchimento de PDIs' : 'Status por calibração'}
            Width='52rem'
        >
            <Flex flexDir={'column'} gap={'.875rem'} px={'1rem'} pt={'1.25rem'} maxH={'85vh'} overflowY={'auto'}>
              {calibracoes.map(e => {
                return <Flex px={'2rem'} border={'1px solid var(--c6)'} py={'1rem'}>
                  <Flex gap={'.5rem'} alignItems={'center'} w={'100%'} pr={'1rem'}>
                    <Avatar src={e.avatar} size={'sm'}/>
                    <Flex gap={'.5rem'} lineHeight={'16px'} alignItems={'center'} fontSize={'14px'}>
                      <strong>{e.nome}</strong>
                      <Divider h={'2rem'} orientation={'vertical'} mx={'1.25rem'} opacity={'.9'} borderColor={'var(--c6)'}/>
                      <Flex
													borderRadius={'6px'}
													color={'#fff'}
													bgColor={ObterCorStatus(e.respondido ?? false)}
													px={'.5rem'} py={'.325rem'}
													fontSize={'14px'}
                          alignItems={'center'}
													fontWeight={'600'}
												>
													{ObterNomeStatus(e.respondido ?? false, e.aprovacao)}
												</Flex>
                    </Flex>
                  </Flex>
                </Flex>
              })}
            </Flex>
            <Flex justifyContent={'center'} gap={'1rem'} p={'1rem'}>
                <ButtonCmp VarColor='c6' onClick={onRequestClose}>Fechar</ButtonCmp>
            </Flex>

        </ModalBase>
  )
}
